import { autorun } from 'mobx';

import { FormStore } from '../entities/form.entity';

import { FormPlugin } from './abstract-form-plugin.entity';

export class BlockCommSpeedPlugin extends FormPlugin<FormStore> {
  connect(form: FormStore): VoidFunction | void {
    const commSpeedField = form.fields['commercialSpeed'];

    if (!commSpeedField) {
      return;
    }

    return autorun(() => {
      const isVisuallyDisabledCommSpeedField = (() => {
        if (form.rigOperationsService.rigOperations.length > 1) {
          return true;
        }

        return form.rigOperationsService.rigOperations.some((r) => r.stages.some((s) => !!s.sections.length));
      })();

      commSpeedField.setIsVisuallyDisabled({ flagId: 'BlockCommSpeedPlugin', value: isVisuallyDisabledCommSpeedField });
    });
  }
}
